import React from 'react'
import { generateTimeSlots } from '../utils/time'

interface TimeLabelsProps {
  startHour: number
  endHour: number
  slotDuration: number
  slotHeight: number
}

export const TimeLabels: React.FC<TimeLabelsProps> = ({
  startHour,
  endHour,
  slotDuration,
  slotHeight,
}) => {
  const slots = generateTimeSlots(startHour, endHour, slotDuration)
  const slotsPerHour = 60 / slotDuration

  return (
    <div
      style={{
        width: '60px',
        flexShrink: 0,
        backgroundColor: '#f9fafb',
        borderRight: '1px solid #e5e7eb',
      }}
    >
      {slots
        .filter((_, idx) => idx % slotsPerHour === 0) // Only show hour labels
        .map((slot) => (
          <div
            key={`label-${slot.hour}`}
            style={{
              height: slotHeight * slotsPerHour, // Height for full hour
              padding: '4px 8px',
              fontSize: '12px',
              color: '#6b7280',
              borderBottom: '1px solid #e5e7eb',
              boxSizing: 'border-box',
            }}
          >
            {slot.label}
          </div>
        ))}
    </div>
  )
}
